import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Breadcrumb = () => {
  const location = useLocation();
  
  const getPageTitle = (pathname) => {
    const routes = {
      '/': 'Home',
      '/southington': 'Southington (06489)',
      '/recipes': 'Recipes (Pane)',
      '/wine': 'Wine (Vino)',
      '/futbol': 'Soccer (Futbol)',
      '/jeep': 'Jeep Adventures',
      '/genes': "Gene's Restaurant",
      '/family-tree': 'Rossetti Family Tree',
      '/calendar': 'Family Calendar'
    };
    
    return routes[pathname] || 'Page';
  };

  // Don't show breadcrumb on home page
  if (location.pathname === '/') {
    return null;
  }

  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      <div className="breadcrumb-container">
        <Link to="/" className="breadcrumb-home">
          <i className="fas fa-home"></i>
          Home
        </Link>
        <span className="breadcrumb-separator">
          <i className="fas fa-chevron-right"></i>
        </span>
        <span className="breadcrumb-current">
          {getPageTitle(location.pathname)}
        </span>
      </div>
    </nav>
  );
};

export default Breadcrumb;